export enum LocationEnum {
  UNDEFINED = 0,
  CINEMA = 1,
  SEAT = 2,
}
